import { render, staticRenderFns } from "./ProductSort.vue?vue&type=template&id=6b5c3112&scoped=true&"
import script from "./ProductSort.vue?vue&type=script&lang=js&"
export * from "./ProductSort.vue?vue&type=script&lang=js&"
import style0 from "./ProductSort.vue?vue&type=style&index=0&id=6b5c3112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5c3112",
  null
  
)

export default component.exports